(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    customElements.define('review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.dots = [...this.querySelectorAll('[data-review-dot]')];

        if (!this.track || this.cards.length < 2 || this.dots.length < 2) return;

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
        });

        this.updateActiveDot = () => {
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.dots.forEach((dot, index) => {
            if (index === closestIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        this.track.addEventListener('scroll', this.updateActiveDot, { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-review-slider')) {
    customElements.define('product-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-product-review-track]');
        this.cards = [...this.querySelectorAll('[data-product-review-card]')];
        this.dots = [...this.querySelectorAll('[data-product-review-dot]')];
        this.previous = this.querySelector('[data-product-review-previous]');
        this.next = this.querySelector('[data-product-review-next]');

        if (!this.track || this.cards.length < 2) return;

        this.activeIndex = 0;

        this.showCard = (index) => {
          const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
          this.cards[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        };

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.showCard(index));
        });

        this.previous?.addEventListener('click', () => this.showCard(this.activeIndex - 1));
        this.next?.addEventListener('click', () => this.showCard(this.activeIndex + 1));

        this.updateControls = () => {
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.activeIndex = closestIndex;
          this.dots.forEach((dot, index) => {
            if (index === closestIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (this.previous) this.previous.disabled = closestIndex === 0;
          if (this.next) this.next.disabled = closestIndex === this.cards.length - 1;
        };

        this.track.addEventListener('scroll', this.updateControls, { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
